module.exports = __webpack_public_path__ + "img/hourglass_green.d050295e.png";